/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {DeaRegistration} from './dea-registration.model';
import {UserModelListService} from '../../common/user-model-list.service';
import {Service} from '../../common/service.class';

@Injectable()
export class DeaRegistrationService extends UserModelListService<DeaRegistration> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'deaRegistration', DeaRegistration);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/dea/dea-registration.service.ts